// Utility for managing school colors
export const applySchoolColors = (colors) => {
  const root = document.documentElement;
  
  // Apply school colors as CSS custom properties
  root.style.setProperty('--school-color-1', colors.school1 || '#ff0000');
  root.style.setProperty('--school-color-2', colors.school2 || '#0000ff');
  root.style.setProperty('--school-color-3', colors.school3 || '#ffff00');
  
  // Also update Tailwind classes dynamically
  const style = document.createElement('style');
  style.id = 'school-colors-dynamic';
  style.textContent = `
    .bg-school-1 { background-color: ${colors.school1 || '#ff0000'} !important; }
    .bg-school-2 { background-color: ${colors.school2 || '#0000ff'} !important; }
    .bg-school-3 { background-color: ${colors.school3 || '#ffff00'} !important; }
    
    .text-school-1 { color: ${colors.school1 || '#ff0000'} !important; }
    .text-school-2 { color: ${colors.school2 || '#0000ff'} !important; }
    .text-school-3 { color: ${colors.school3 || '#ffff00'} !important; }
    
    .border-school-1 { border-color: ${colors.school1 || '#ff0000'} !important; }
    .border-school-2 { border-color: ${colors.school2 || '#0000ff'} !important; }
    .border-school-3 { border-color: ${colors.school3 || '#ffff00'} !important; }
  `;
  
  // Remove existing style if it exists
  const existingStyle = document.getElementById('school-colors-dynamic');
  if (existingStyle) {
    existingStyle.remove();
  }
  
  document.head.appendChild(style);
};

export const getContrastColor = (hexColor) => {
  if (!hexColor) return '#000000';
  
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness > 128 ? '#000000' : '#ffffff';
};

export const getSchoolColorStyle = (colorKey, colors) => {
  const color = colors[colorKey];
  if (!color) return {};
  
  return {
    backgroundColor: color,
    borderColor: color,
    color: getContrastColor(color)
  };
};

export const defaultSchoolColors = {
  school1: '#ff0000',
  school2: '#0000ff',
  school3: '#ffff00'
};
